import { TableHeader, TableHeaderCell, TableRow } from '@shipengine/giger';

import { useTranslation } from '@packlink/translation-provider';

export const TransactionsTableHeader = (): JSX.Element => {
    const { t } = useTranslation();

    return (
        <TableHeader>
            <TableRow>
                <TableHeaderCell>{t('transactions.header.id')}</TableHeaderCell>
                <TableHeaderCell>{t('transactions.header.date')}</TableHeaderCell>
                <TableHeaderCell>{t('transactions.header.amount')}</TableHeaderCell>
                <TableHeaderCell>{t('transactions.header.type')}</TableHeaderCell>
            </TableRow>
        </TableHeader>
    );
};
